import React, { useState } from 'react';
import { historyPropType } from '~/config/routerPropTypes';
import {
  newMedicalAppointments,
  showMedicalAppointments
} from '~/config/routes';
import Request  from '~/providers/Request';
import MedicalAppointmentsRecord from '~/records/MedicalAppointmentsRecord';
import Form from './FormNew';

function NewRecord({history}){
  const [record, setRecord] = useState(new MedicalAppointmentsRecord());
  const [ loading, setLoading] = useState(false);

  async function onSubmit (saveAndContinue){
    const data = record.toParams();

    // if (!data.data.attributes.doctor_id) {
    //   toast.error(t('medicalAppointments.extras.doctor_required'));
    //   return false;
    // }

    setLoading(true);
    Request.post('/admin/medical_appointment', data, {}, { controller: 'medicalAppointments' })
      .then((resp) => {
        setLoading(false);
        if(saveAndContinue) history.push(newMedicalAppointments.spec);
        else history.push(showMedicalAppointments.reverse(resp.data));
      })
      .catch(e => {
        console.error(e);
        setLoading(false);
      });
  }

  const handleChange = (attrs) => {
    setRecord( record.updateAttributes(attrs) );
  };

  return(
    <Form
      onSubmit={(saveAndContinue) => onSubmit(saveAndContinue)}
      setRecord={setRecord}
      record={record}
      handleChange={handleChange}
      loading={loading}
    />
  );
}

NewRecord.propTypes={
  history: historyPropType,
};

export default NewRecord;
